// extracted by mini-css-extract-plugin
module.exports = {"launchpad":"index_launchpad__1J-or"};